export enum enCommentType {
  myComments = 'myComments',
  allComments = 'allComments',
}

export enum enTypeComment {
  ownComment = 'my-comments',
  comments = 'comments',
}

export enum enCommentTabs {
  myComments = 0,
  allComments = 1,
}
export interface ICommentData {
  createdAt: Date;
  id: number;
  status: number;
  text: string;
  totalReplies: number;
  user: {
    name: string;
    avatar?: string;
  };
  answers?: Array<ICommentData>;
}
export interface ILessonComment {
  page: {
    page: number;
    size: number;
  };
  data: ICommentData[];
  isFetching: boolean;
  total_pages: number;
  total_rows: {
    total: number;
  };
}
